import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Logo from 'images/landing/Logo.svg';

export default function () {
    return(
        <footer className="main-footer">
            <div className="row justify-content-between footer-top">
                <div className="col-md-7">
                    <div className="copyright">
                        <Link className="logo" to="/home">
                            <img src={Logo} />
                        </Link>
                    </div>
                </div>
                <div className="col-md-5 order-md-1">
                    <ul className="foot-list">
                        <li>
                            <Link to="/about-us">
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact-us">
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/terms-of-service">
                                Terms of Service
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy-policy">
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link to="/cookies-policy">
                                Cookies Policy
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <span>{`© Prescription Revision Ltd ${moment().format('YYYY')}. All rights reserved.`}</span>
        </footer>
    )
}



// WEBPACK FOOTER //
// ./src/modules/core/containers/Footer.jsx